<app-configuration-page
  title="Import Spreadsheet"
  description="Upload a spreadsheet to import studio records in bulk."
  [breadcrumbs]="[{ label: 'Simple Import' }, { label: 'Import Spreadsheet' }]">

  <app-simple-import-spreadsheet></app-simple-import-spreadsheet>

</app-configuration-page>
